export const VennDiagram = () => {
  return (
    <svg
      height="512"
      viewBox="0 0 64 64"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_3591406"
    >
      <g id="_39_Diagram_Venn" fill="currentColor" opacity={0.3} data-name="39 Diagram Venn">
        <path d="m30.54 44.39c-6.01-6.76-5.99-18.05.04-24.8a12.514 12.514 0 0 1 1.42-1.398 17.763 17.763 0 0 0 -12-4.192c-23.91 0-23.971 36 0 36a17.865 17.865 0 0 0 12.024-4.156 14.68 14.68 0 0 1 -1.484-1.454z"></path>
        <path d="m44 14a17.723 17.723 0 0 0 -12 4.193 14.968 14.968 0 0 1 1.45 1.417c6.04 6.76 6.08 18.06.04 24.81a14.083 14.083 0 0 1 -1.456 1.426 17.758 17.758 0 0 0 11.966 4.154c24.12 0 23.881-36 0-36z"></path>
      </g>
      <g id="Layer_52" data-name="Layer 52">
        <path
          d="m44 14a17.723 17.723 0 0 0 -12 4.2 17.762 17.762 0 0 0 -12-4.2c-23.91 0-23.971 36 0 36a17.864 17.864 0 0 0 12.028-4.16 17.756 17.756 0 0 0 11.972 4.16c24.12 0 23.881-36 0-36zm-12 28.958a17.159 17.159 0 0 1 .026-21.958c5.318 5.982 5.283 15.952-.026 21.958zm-12-26.958a15.913 15.913 0 0 1 10.569 3.6c-6.014 6.749-6.035 18.026-.037 24.785a15.821 15.821 0 0 1 -10.532 3.615c-21.254 0-21.307-32 0-32zm24 32a15.8 15.8 0 0 1 -10.5-3.593c6.026-6.749 5.982-18.031-.044-24.792a15.809 15.809 0 0 1 10.544-3.615c21.44 0 21.227 32 0 32z"
          fill="currentColor"
        ></path>
      </g>
    </svg>
  );
};
